// Whether a place is a member of the given module/collection.
//
// IMPORTANT — preserved divergence (rule 10): the call sites in
// PlaceListModule are NOT all identical.
//   - The folder-grouping / folder-list sites use the full THREE-clause form
//     (moduleId, moduleIds, moduleLinks): pass `{ includeModuleLinks: true }`.
//   - The two collection-BADGE sites use a TWO-clause form with NO moduleLinks
//     check: pass `{ includeModuleLinks: false }`.
// Unifying to a single three-clause predicate would newly show a badge /
// mark the current collection for places linked only via `moduleLinks`.
// This option preserves both behaviors verbatim — do NOT collapse it.
//
// NOTE: the main `places` list filter (the early-return chain at the top of
// PlaceListModule) has DIFFERENT short-circuit semantics (it returns on the
// first present field rather than OR-ing all three) and is intentionally NOT
// expressed through this helper.
export function placeBelongsToModule(
  place: any,
  moduleId: string,
  { includeModuleLinks }: { includeModuleLinks: boolean },
): boolean {
  if (includeModuleLinks) {
    return (
      place.moduleId === moduleId ||
      place.moduleIds?.includes(moduleId) ||
      place.moduleLinks?.some((l: any) => l.moduleId === moduleId)
    );
  }
  return place.moduleIds?.includes(moduleId) || place.moduleId === moduleId;
}

// Find the label of the first folder (collection) the place belongs to, using
// the two-clause (badge) membership form. Returns undefined if none match.
export function findPlaceFolderLabel(
  place: any,
  folders: Array<{ id: string; label: string }>,
): string | undefined {
  return folders.find(f => placeBelongsToModule(place, f.id, { includeModuleLinks: false }))?.label;
}
